import { AppRoutes, UserRoles } from './core/constants/routes';

import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';
import { roleGuard } from './core/guards/role-guard';

export const MainRoutes: Routes = [
  {
    path: AppRoutes.Login,
    loadChildren: () =>
      import('./features/authentication/authentication.routes').then((m) => m.AUTHROUTES),
  },
  {
    path: AppRoutes.Home,
    loadChildren: () =>
      import('./layouts/hubview/hubview-layout/hubview-layout.routes').then(
        (m) => m.HUBVIEW_LAYOUT_ROUTES,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      preload: true,
      allowedRoles: [UserRoles.Admin, UserRoles.Operator, UserRoles.Maintenance],
    },
  },
  {
    path: AppRoutes.Kiosk,
    loadComponent: () =>
      import('./layouts/kiosk-gate/kiosk-layout/kiosk-layout').then((m) => m.KioskLayout),
  },
  {
    path: AppRoutes.GateCheck,
    loadComponent: () =>
      import('./layouts/mobile-gate/mobile-gate-layout/mobile-gate-layout').then(
        (m) => m.MobileGateLayout,
      ),
  },
  {
    path: AppRoutes.GateOperatorHome,
    loadChildren: () =>
      import('./layouts/yard-pass/components/yard-pass-layout/yard-pass-layout.routes').then(
        (m) => m.TABLET_ROUTES,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      allowedRoles: [UserRoles.Admin, UserRoles.GateOperator, UserRoles.GateAdmin],
      featureKey: 'YardPass',
    },
  },
];
